export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10661.c35804b4.jpg";